var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TrialLockoutOverlay.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4526b9c8!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TrialLockoutOverlay.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/buybox/TrialLockoutOverlay.vue
// module id = 671
// module chunks = 2